export default __webpack_public_path__ + "static/media/sports (9).1ab036ec.jpg";